module.exports = __webpack_public_path__ + "img/AssaAbloy_ikon_guide.06b84e97.png";